module.exports = {
  label: {
    headerTitle: 'Visitor Management',
    passport: 'ID/Passport',
    addHeaderTitle: 'Add Visitor Management',
    changeLogo: 'Do you want to change Photo?',
    addGroups: 'Do you want to add group',
    uploadThePhoto: 'Upload The Photo',
    editHeaderTitle: 'Edit Visitor Management',
    company: 'Company',
    phoneNumber: 'Cell Phone Number',
    WhatsAppNumber: 'WhatsApp Number',
    uploadPhoto: 'Upload Your Photo',
    selectCompany: 'Select Company',
    communicationType: 'Communication Type',
    allowShareInformation: 'By submitting this form and information consents to the transfer, processing, or storage of such Personal Information.',
    notAllowedShareInformation: 'You cannot proceed with your registration.',
    site: 'Site',
    selectsite: 'Select Site',
    userName: 'User Name',
    password: 'Password',
    name: 'Name',
    surname: 'Surname',
    emailAddress: 'Email Address',
    roles: 'Roles',
    search: 'Search...',
    addPerson: "Add other person",
    relationship: "Relationship with me",
    relation: "Relation",
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      continue: 'Continue',
      submit: 'Submit',
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel'
    }
  }
}
